import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readAvailable27gpepp0hyyts as readAvailable } from './core/Input.mjs';
import { readBytesj5m5qe40si0k as readBytes } from './core/Buffers.mjs';
import {
  get_remaining1lapv95kcmm0y as get_remaining,
  discard3ugntd47xyll6 as discard,
} from './core/ByteReadPacket.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { close3semq7pafb42g as close } from './ByteWriteChannelOperations.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { ByteChannelScanner1h148q1m3y1ey as ByteChannelScanner } from './ByteChannelScanner.mjs';
import {
  LineEnding_Default_getInstance1v5asezcrl1hi as LineEnding_Default_getInstance,
  LineEnding_Lenient_getInstance1bc8w98h8if6n as LineEnding_Lenient_getInstance,
} from './LineEnding.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { readByteString2hnsbql6t4ads as readByteString } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/ByteStrings.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { TooLongLineException2d6ls946t46wx as TooLongLineException } from './charsets/Encoding.mjs';
import {
  readStringo8i62qxt5m4m as readString,
  readString3v6duspiz33tv as readString_0,
} from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Utf8.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *readBuffer(_this__u8e3s4, $completion) {
  var result = new (Buffer())();
  while (!_this__u8e3s4.get_isClosedForRead_ajcc1s_k$()) {
    if (_this__u8e3s4.get_readBuffer_yjmj9b_k$().exhausted_p1jt55_k$()) {
      yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion);
    }
    result.transferFrom_v29myr_k$(_this__u8e3s4.get_readBuffer_yjmj9b_k$());
  }
  rethrowCloseCauseIfNeeded(_this__u8e3s4);
  return result;
}
function *readAvailable_0(_this__u8e3s4, buffer, offset, length, $completion) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  if (_this__u8e3s4.get_isClosedForRead_ajcc1s_k$())
    return -1;
  if (_this__u8e3s4.get_readBuffer_yjmj9b_k$().exhausted_p1jt55_k$()) {
    yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion);
  }
  if (_this__u8e3s4.get_isClosedForRead_ajcc1s_k$())
    return -1;
  return readAvailable(_this__u8e3s4.get_readBuffer_yjmj9b_k$(), buffer, offset, length);
}
function *toByteArray(_this__u8e3s4, $completion) {
  return readBytes(yield* /*#__NOINLINE__*/readBuffer(_this__u8e3s4, $completion));
}
function *copyTo(_this__u8e3s4, channel, limit, $completion) {
  var remaining = limit;
  try {
    while (!_this__u8e3s4.get_isClosedForRead_ajcc1s_k$() && remaining > 0n) {
      if (_this__u8e3s4.get_readBuffer_yjmj9b_k$().exhausted_p1jt55_k$()) {
        yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion);
      }
      var tmp0 = remaining;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = get_remaining(_this__u8e3s4.get_readBuffer_yjmj9b_k$());
      var count = tmp0 <= b ? tmp0 : b;
      _this__u8e3s4.get_readBuffer_yjmj9b_k$().readTo_3vtbf7_k$(channel.get_writeBuffer_t7kuc6_k$(), count);
      remaining = subtract(remaining, count);
      yield* channel.flush_4wsz1p_k$($completion);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      _this__u8e3s4.cancel_9i2dv0_k$(cause);
      close(channel, cause);
      throw cause;
    } else {
      throw $p;
    }
  }
  finally {
    yield* channel.flush_4wsz1p_k$($completion);
  }
  return subtract(limit, remaining);
}
function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.get_closedCause_o1qcj8_k$();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function *discard_0(_this__u8e3s4, max, $completion) {
  max = max === VOID ? 9223372036854775807n : max;
  var remaining = max;
  while (remaining > 0n && !_this__u8e3s4.get_isClosedForRead_ajcc1s_k$()) {
    if (get_availableForRead(_this__u8e3s4) === 0) {
      yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion);
    }
    var tmp0 = remaining;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(_this__u8e3s4.get_readBuffer_yjmj9b_k$());
    var count = tmp0 <= b ? tmp0 : b;
    discard(_this__u8e3s4.get_readBuffer_yjmj9b_k$(), count);
    remaining = subtract(remaining, count);
  }
  return subtract(max, remaining);
}
function *skipIfFound(_this__u8e3s4, byteString, $completion) {
  if (equals(yield* peek(_this__u8e3s4, byteString.get_size_woubt6_k$(), $completion), byteString)) {
    yield* /*#__NOINLINE__*/discard_0(_this__u8e3s4, fromInt(byteString.get_size_woubt6_k$()), $completion);
    return true;
  }
  return false;
}
function *readPacket(_this__u8e3s4, packet, $completion) {
  var result = new (Buffer())();
  $l$loop: while (result.get_size_woubt6_k$() < fromInt(packet)) {
    if (_this__u8e3s4.get_readBuffer_yjmj9b_k$().exhausted_p1jt55_k$()) {
      yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion);
    }
    if (_this__u8e3s4.get_isClosedForRead_ajcc1s_k$())
      break $l$loop;
    if (get_remaining(_this__u8e3s4.get_readBuffer_yjmj9b_k$()) > subtract(numberToLong(packet), result.get_size_woubt6_k$())) {
      _this__u8e3s4.get_readBuffer_yjmj9b_k$().readTo_3vtbf7_k$(result, subtract(numberToLong(packet), result.get_size_woubt6_k$()));
    } else {
      _this__u8e3s4.get_readBuffer_yjmj9b_k$().transferTo_lu4ka2_k$(result);
    }
  }
  if (result.get_size_woubt6_k$() < fromInt(packet)) {
    throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$('Not enough data available, required ' + packet + ' bytes but only ' + result.get_size_woubt6_k$().toString() + ' available');
  }
  return result;
}
function *readUntil(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  ignoreMissing = ignoreMissing === VOID ? false : ignoreMissing;
  return yield* (new (ByteChannelScanner())(_this__u8e3s4, matchString, writeChannel, limit)).findNext_k7w4m8_k$(ignoreMissing, $completion);
}
function *readLineStrictTo(_this__u8e3s4, out, limit, lineEnding, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  lineEnding = lineEnding === VOID ? LineEnding_Default_getInstance() : lineEnding;
  // Inline function 'kotlin.require' call
  if (!(limit >= 0n)) {
    var message = 'Limit (' + limit.toString() + ') should be non-negative';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return yield* internalReadLineTo(_this__u8e3s4, out, limit, lineEnding.equals(LineEnding_Lenient_getInstance()), true, $completion);
}
function get_availableForRead(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4.get_readBuffer_yjmj9b_k$().get_buffer_bmaafd_k$().get_size_woubt6_k$());
}
function *peek(_this__u8e3s4, count, $completion) {
  if (_this__u8e3s4.get_isClosedForRead_ajcc1s_k$())
    return null;
  if (!(yield* _this__u8e3s4.awaitContent_q7m0p7_k$(count, $completion)))
    return null;
  return readByteString(_this__u8e3s4.get_readBuffer_yjmj9b_k$().peek_21nx7_k$(), count);
}
function *internalReadLineTo(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, $completion) {
  var readBuffer = _this__u8e3s4.get_readBuffer_yjmj9b_k$();
  if (readBuffer.exhausted_p1jt55_k$()) {
    yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion);
  }
  if (_this__u8e3s4.get_isClosedForRead_ajcc1s_k$())
    return -1n;
  var consumed = {_v: 0n};
  var outBuffer = {_v: null};
  try {
    $l$loop: while (consumed._v < limit && !_this__u8e3s4.get_isClosedForRead_ajcc1s_k$()) {
      var limitLeft = subtract(limit, consumed._v);
      var lfIndex = indexOf(readBuffer, 10, VOID, limitLeft);
      var crIndex = internalReadLineTo$scanForSoleCr(readBuffer, lenientLineEnding, lfIndex, limitLeft);
      if (crIndex >= 0n) {
        internalReadLineTo$appendOrBuffer(outBuffer, out, readBuffer, consumed, crIndex);
        discard(readBuffer, 1n);
        return consumed._v;
      }
      if (lfIndex === 0n) {
        discard(readBuffer, 1n);
        return consumed._v;
      }
      if (lfIndex > 0n) {
        var tmp;
        var tmp_0 = readBuffer.get_buffer_bmaafd_k$();
        // Inline function 'kotlin.Long.minus' call
        var tmp$ret$0 = subtract(lfIndex, fromInt(1));
        if (tmp_0.get_f9lzxq_k$(tmp$ret$0) === 13) {
          tmp = 1n;
        } else {
          tmp = 0n;
        }
        var isCrlf = tmp;
        internalReadLineTo$appendOrBuffer(outBuffer, out, readBuffer, consumed, subtract(lfIndex, isCrlf));
        discard(readBuffer, add(numberToLong(1), isCrlf));
        return consumed._v;
      }
      // Inline function 'kotlin.comparisons.minOf' call
      var b = get_remaining(readBuffer);
      var count = limitLeft <= b ? limitLeft : b;
      var tmp_1 = readBuffer.get_buffer_bmaafd_k$();
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$2 = subtract(count, fromInt(1));
      if (tmp_1.get_f9lzxq_k$(tmp$ret$2) === 13) {
        // Inline function 'kotlin.Long.minus' call
        var tmp$ret$3 = subtract(count, fromInt(1));
        internalReadLineTo$appendOrBuffer(outBuffer, out, readBuffer, consumed, tmp$ret$3);
        if (yield* internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion)) {
          return consumed._v;
        } else {
          internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, 1n);
        }
      } else {
        internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, count);
      }
      if (consumed._v < limit && get_remaining(readBuffer) === 0n && !(yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion)))
        break $l$loop;
    }
    if (consumed._v === 0n && _this__u8e3s4.get_isClosedForRead_ajcc1s_k$())
      return -1n;
    // Inline function 'kotlin.check' call
    if (!(consumed._v <= limit)) {
      var message = 'Consumed bytes exceed the limit: ' + consumed._v.toString() + ' > ' + limit.toString() + ". It's an implementation bug, please report it.";
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
    }
    if (consumed._v === limit) {
      if (limit === 9223372036854775807n)
        throw TooLongLineException().new_io_ktor_utils_io_charsets_TooLongLineException_emlsi1_k$('Max line length exceeded');
      if (get_remaining(readBuffer) === 0n && !(yield* _this__u8e3s4.awaitContent$default_rxihsg_k$(VOID, $completion))) {
        throwEndOfStreamException(consumed._v);
      }
      var tmp0_subject = readBuffer.get_buffer_bmaafd_k$().get_f9lzxq_k$(0n);
      if (tmp0_subject === 10) {
        discard(readBuffer, 1n);
        return consumed._v;
      } else if (tmp0_subject === 13)
        if (yield* internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion)) {
          return consumed._v;
        }
      throwTooLongLineException(limit);
    }
    if (throwOnIncompleteLine) {
      throwEndOfStreamException(consumed._v);
    }
    return consumed._v;
  }finally {
    if (!(outBuffer._v == null)) {
      out.append_jgojdo_k$(readString(outBuffer._v));
    }
  }
}
function throwEndOfStreamException(consumed) {
  throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$('Unexpected end of stream after reading ' + consumed.toString() + ' bytes');
}
function throwTooLongLineException(limit) {
  throw TooLongLineException().new_io_ktor_utils_io_charsets_TooLongLineException_emlsi1_k$('Line exceeds limit of ' + limit.toString() + ' bytes');
}
function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.get_closedCause_o1qcj8_k$();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, count) {
  if (count > 0n) {
    if (outBuffer._v == null) {
      outBuffer._v = new (Buffer())();
    }
    outBuffer._v.write_9ocf0z_k$(readBuffer, count);
    consumed._v = add(consumed._v, count);
  }
}
function internalReadLineTo$appendOrBuffer(outBuffer, $out, readBuffer, consumed, count) {
  if (outBuffer._v == null) {
    if (count > 0n) {
      $out.append_jgojdo_k$(readString_0(readBuffer, count));
      consumed._v = add(consumed._v, count);
    }
  } else {
    internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, count);
  }
}
function internalReadLineTo$scanForSoleCr(_this__u8e3s4, $lenientLineEnding, lfIndex, limitLeft) {
  if (!$lenientLineEnding)
    return -1n;
  var tmp;
  if (lfIndex === -1n) {
    // Inline function 'kotlin.Long.minus' call
    var this_0 = get_remaining(_this__u8e3s4);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = subtract(this_0, fromInt(1));
    tmp = limitLeft <= b ? limitLeft : b;
  } else if (lfIndex === 0n) {
    tmp = 0n;
  } else {
    // Inline function 'kotlin.Long.minus' call
    tmp = subtract(lfIndex, fromInt(1));
  }
  var endIndex = tmp;
  return indexOf(_this__u8e3s4, 13, VOID, endIndex);
}
function *internalReadLineTo$discardCrlfOrCr(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, $completion) {
  if ((get_remaining(_this__u8e3s4) >= 2n || (yield* $this_internalReadLineTo.awaitContent_q7m0p7_k$(2, $completion))) && _this__u8e3s4.get_buffer_bmaafd_k$().get_f9lzxq_k$(1n) === 10) {
    discard(_this__u8e3s4, 2n);
    return true;
  }
  if ($lenientLineEnding) {
    discard(_this__u8e3s4, 1n);
    return true;
  }
  return false;
}
//region block: exports
export {
  copyTo as copyTo2t9ovypu2ttur,
  readAvailable_0 as readAvailable3nvldm7ch5xu5,
  readBuffer as readBuffery45c0omfxhxc,
  readLineStrictTo as readLineStrictTo1b1nwo5trwh7s,
  readPacket as readPacket290wjvm56mmfy,
  readUntil as readUntil2ls7o0c1kzd4x,
  skipIfFound as skipIfFoundarb6fjv6fvg7,
  toByteArray as toByteArraylei52b7x53md,
  rethrowCloseCauseIfNeeded as rethrowCloseCauseIfNeeded3ixo8wl4o3bz4,
  rethrowCloseCauseIfNeeded_0 as rethrowCloseCauseIfNeeded2q8fs9csuucwc,
};
//endregion

//# sourceMappingURL=ByteReadChannelOperations.mjs.map
